export default __webpack_public_path__ + "static/media/14.756cf328.webp";